import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import NavigationButton from "./NavigationButton";

const IndexNavigation = ({
  currentIndex,
  totalCount,
  onNext,
  onPrev,
  className = "flex justify-center items-center space-x-4 mb-6",
  buttonClassName = "p-3 bg-gray-100 hover:bg-gray-200 rounded-full transition-colors",
  counterClassName = "text-sm text-gray-500",
  iconClassName = "h-6 w-6 text-gray-600"
}) => {
  return (
    <div className={className}>
      <NavigationButton
        onClick={onPrev}
        className={buttonClassName}
      >
        <ChevronLeft className={iconClassName} />
      </NavigationButton>
      <span className={counterClassName}>
        {currentIndex + 1} / {totalCount}
      </span>
      <NavigationButton
        onClick={onNext}
        className={buttonClassName}
      >
        <ChevronRight className={iconClassName} />
      </NavigationButton>
    </div>
  );
};

export default IndexNavigation;
